(function ($) {
  "use strict";

  // 确保 jQuery 可用
  if (typeof $ === "undefined") {
    console.error("jQuery is not loaded");
    return;
  }

  class AuthManager {
    constructor() {
      this.init();
    }

    init() {
      this.initModal();
      this.initTabs();
      this.initForms();
      this.initGoogleLogin();
      console.log("Auth manager initialized");
    }

    initModal() {
      const $modal = $("#login-modal");
      if (!$modal.length) return;

      // 打开模态框
      $(document).on("click", '[data-modal="login"]', async (e) => {
        e.preventDefault();

        // 在显示模态框之前加载头像选择器
        try {
          const response = await $.ajax({
            url: gamehubVars.ajaxurl,
            type: "POST",
            data: {
              action: "gamehub_load_avatar_selector",
              nonce: gamehubVars.nonce,
            },
          });

          if (response.success) {
            $("#avatar-selector-container")
              .html(response.data.html)
              .addClass("loaded");

            // 初始化头像选择器的事件
            this.initAvatarSelector();
          }
        } catch (error) {
          console.error("Failed to load avatar selector:", error);
        }

        // 显示模态框
        this.showModal($modal);
      });

      // 关闭模态框
      $modal.on("click", (e) => {
        // 如果点击的是遮罩层或关闭按钮或其子元素
        if (
          $(e.target).hasClass("modal-overlay") ||
          $(e.target).closest(".modal-close").length
        ) {
          this.hideModal($modal);
        }
      });

      // ESC 键关闭
      $(document).on("keydown", (e) => {
        if (e.key === "Escape" && $modal.hasClass("active")) {
          this.hideModal($modal);
        }
      });
    }

    showModal($modal) {
      $modal.addClass("active");
      $("body").addClass("modal-open");
    }

    hideModal($modal) {
      $modal.removeClass("active");
      $("body").removeClass("modal-open");
    }

    initTabs() {
      $(document).on("click", ".modal-tabs .tab-button", async (e) => {
        const $button = $(e.currentTarget);
        const $modal = $button.closest(".modal");
        const tabId = $button.attr("data-tab");

        console.log("Tab clicked:", {
          button: $button,
          tabId: tabId,
        });

        // 更新按钮状态
        $modal.find(".tab-button").removeClass("active");
        $button.addClass("active");

        // 更新内容区域
        $modal.find(".tab-content").removeClass("active");

        const tabSelector = "#" + tabId + "-tab";
        console.log("Looking for tab:", tabSelector);

        const $targetTab = $modal.find(tabSelector);
        if ($targetTab.length) {
          $targetTab.addClass("active");

          // 如果是注册标签页且头像选择器还未加载
          if (
            tabId === "register" &&
            !$("#avatar-selector-container").hasClass("loaded")
          ) {
            try {
              const response = await $.ajax({
                url: gamehubVars.ajaxurl,
                type: "POST",
                data: {
                  action: "gamehub_load_avatar_selector",
                  nonce: gamehubVars.nonce,
                },
              });

              if (response.success) {
                $("#avatar-selector-container")
                  .html(response.data.html)
                  .addClass("loaded");

                // 初始化头像选择器的事件
                this.initAvatarSelector();
              }
            } catch (error) {
              console.error("Failed to load avatar selector:", error);
            }
          }
        } else {
          console.error("Tab not found:", tabSelector);
        }
      });
    }

    // 添加头像选择器初始化方法
    initAvatarSelector() {
      $('.avatar-option input[type="radio"]').on("change", function () {
        $('input[name="user_avatar"]').val($(this).val());
      });

      $(".refresh-avatars").on("click", async function () {
        try {
          const response = await $.ajax({
            url: gamehubVars.ajaxurl,
            type: "POST",
            data: {
              action: "gamehub_refresh_avatars",
              nonce: gamehubVars.nonce,
            },
          });

          if (response.success) {
            $(".avatar-grid").html(response.data.html);
            // 选中第一个新头像
            $('.avatar-option:first-child input[type="radio"]')
              .prop("checked", true)
              .trigger("change");
          }
        } catch (error) {
          console.error("Failed to refresh avatars:", error);
        }
      });
    }

    initForms() {
      // 登录表单提交
      $("#login-form").on("submit", (e) => {
        e.preventDefault();
        this.handleLogin(e.target);
      });

      // 注册表单提交
      $("#register-form").on("submit", (e) => {
        e.preventDefault();
        this.handleRegister(e.target);
      });

      // 添加密码验证
      const $password = $("#register-password");
      const $confirmPassword = $("#register-confirm-password");
      const $passwordHint = $(".password-hint");
      const $confirmPasswordHint = $(".confirm-password-hint");
      const $registerSubmit = $('#register-form [type="submit"]');

      // 密码强度验证
      $password.on("input", (e) => {
        const password = $(e.target).val();
        let message = "";
        let isValid = true;

        if (password.length < 6) {
          message = "Password must be at least 6 characters";
          isValid = false;
        } else if (!/[A-Z]/.test(password)) {
          message = "Password must contain at least one uppercase letter";
          isValid = false;
        } else if (!/[a-z]/.test(password)) {
          message = "Password must contain at least one lowercase letter";
          isValid = false;
        } else if (!/[0-9]/.test(password)) {
          message = "Password must contain at least one number";
          isValid = false;
        }

        $passwordHint
          .text(message)
          .removeClass("success error")
          .addClass(isValid ? "success" : "error");

        this.validatePasswords($password, $confirmPassword, $registerSubmit);
      });

      // 密码匹配验证
      $confirmPassword.on("input", (e) => {
        this.validatePasswords($password, $confirmPassword, $registerSubmit);
      });

      // 修改用户名实时验证
      const $username = $('[name="username"]');
      let usernameCheckTimeout;

      $username.on("input", (e) => {
        const username = $(e.target).val().trim();
        const $hint = $(".username-hint");

        if (!username) {
          $hint.text("").removeClass("success error");
          return;
        }

        let message = "";
        let isValid = true;

        if (username.length < 3) {
          message = "Username must be at least 3 characters";
          isValid = false;
        } else if (username.length > 50) {
          message = "Username cannot exceed 50 characters";
          isValid = false;
        } else if (!/^[a-zA-Z0-9_]+$/.test(username)) {
          message =
            "Username can only contain letters, numbers and underscores";
          isValid = false;
        } else {
          // 清除之前的超时
          clearTimeout(usernameCheckTimeout);

          // 设置新的超时来检查用户名是否存在
          usernameCheckTimeout = setTimeout(() => {
            this.checkUsernameExists(username, $hint);
          }, 500);

          return; // 等待异步检查
        }

        $hint
          .text(message)
          .removeClass("success error")
          .addClass(isValid ? "success" : "error");
      });
    }

    validatePasswords($password, $confirmPassword, $submitButton) {
      const password = $password.val();
      const confirmPassword = $confirmPassword.val();
      const $confirmHint = $(".confirm-password-hint");

      if (!confirmPassword) {
        $confirmHint.text("").removeClass("success error");
        $submitButton.prop("disabled", true);
        return;
      }

      if (password === confirmPassword) {
        $confirmHint
          .text("Passwords match")
          .removeClass("error")
          .addClass("success");
        $submitButton.prop("disabled", false);
      } else {
        $confirmHint
          .text("Passwords do not match")
          .removeClass("success")
          .addClass("error");
        $submitButton.prop("disabled", true);
      }
    }

    async handleLogin(form) {
      const $form = $(form);
      const $submit = $form.find('[type="submit"]');
      $submit.prop("disabled", true);

      console.log("Login attempt - Form data:", {
        username: $form.find('[name="username"]').val(),
        remember: $form.find('[name="remember"]').prop("checked"),
      });

      try {
        const response = await $.ajax({
          url: gamehubVars.ajaxurl,
          type: "POST",
          data: {
            action: "gamehub_login",
            nonce: gamehubVars.nonce,
            username: $form.find('[name="username"]').val(),
            password: $form.find('[name="password"]').val(),
            remember: $form.find('[name="remember"]').prop("checked"),
          },
        });

        console.log("Login response:", response);

        if (response.success) {
          console.log("Login successful - User data:", response.data);

          // 检查用户角色和权限
          if (response.data.user_info) {
            console.log("User roles:", response.data.user_info.roles);
            console.log(
              "Can access admin:",
              response.data.user_info.can_access_admin
            );
          }

          window.location.reload();
        } else {
          console.error("Login failed:", response.data.message);
          this.showError(response.data.message);
        }
      } catch (error) {
        console.error("Login error:", error);
        this.showError("An error occurred. Please try again.");
      } finally {
        $submit.prop("disabled", false);
      }
    }

    async handleRegister(form) {
      const $form = $(form);
      const $submit = $form.find('[type="submit"]');

      // 获取并清理用户名
      const username = $form.find('[name="username"]').val().trim();

      // 详细的用户名验证
      if (!username) {
        this.showError("Please enter a username");
        return;
      }

      // 检查长度
      if (username.length < 3 || username.length > 50) {
        this.showError("Username must be between 3 and 50 characters");
        return;
      }

      // 检查字符
      if (!/^[a-zA-Z0-9_]+$/.test(username)) {
        this.showError(
          "Username can only contain letters, numbers and underscores"
        );
        console.log("Invalid username:", username);
        return;
      }

      // 添加调试信息
      console.log("Username validation passed:", {
        username: username,
        length: username.length,
        pattern: /^[a-zA-Z0-9_]+$/.test(username),
      });

      // 验证密码
      const password = $form.find('[name="password"]').val();
      const confirmPassword = $form.find('[name="confirm_password"]').val();

      if (password.length < 6) {
        this.showError("Password must be at least 6 characters long");
        return;
      }

      if (password !== confirmPassword) {
        this.showError("Passwords do not match");
        return;
      }

      // 验证头像
      const avatar = $form.find('[name="user_avatar"]').val();
      if (!avatar) {
        this.showError("Please select an avatar");
        return;
      }

      $submit.prop("disabled", true);

      try {
        console.log("Sending registration request for:", username);
        const response = await $.ajax({
          url: gamehubVars.ajaxurl,
          type: "POST",
          data: {
            action: "gamehub_register",
            nonce: gamehubVars.nonce,
            username: username,
            password: password,
            avatar: avatar,
          },
        });

        console.log("Registration response:", response);

        if (response.success) {
          this.showSuccess("Registration successful! Redirecting...");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          this.showError(
            response.data.message || "Registration failed. Please try again."
          );
        }
      } catch (error) {
        console.error("Registration error:", error);
        this.showError(
          "An error occurred during registration. Please try again."
        );
      } finally {
        $submit.prop("disabled", false);
      }
    }

    initGoogleLogin() {
      if (typeof google === "undefined") return;

      google.accounts.id.initialize({
        client_id: gamehubVars.googleClientId,
        callback: this.handleGoogleLogin.bind(this),
      });

      $(".google-login-btn").on("click", () => {
        google.accounts.id.prompt();
      });
    }

    async handleGoogleLogin(response) {
      try {
        const result = await $.ajax({
          url: gamehubVars.ajaxurl,
          type: "POST",
          data: {
            action: "gamehub_google_login",
            nonce: gamehubVars.nonce,
            id_token: response.credential,
          },
        });

        if (result.success) {
          window.location.reload();
        } else {
          this.showError(result.data.message);
        }
      } catch (error) {
        this.showError("Google login failed. Please try again.");
      }
    }

    showError(message) {
      console.error("Auth Error:", message);

      // 确保 message 是字符串
      const errorMessage =
        typeof message === "string" ? message : "An error occurred";

      // 创建 toast 容器（如果不存在）
      if (!$("#toast-container").length) {
        $("body").append(`
          <div id="toast-container" class="toast-container" style="
            position: fixed;
            top: 20px;
            right: 20px;
            z-index: 9999;
          "></div>
        `);
      }

      // 创建 toast 元素
      const $toast = $(`
        <div class="game-toast error" style="
          margin-bottom: 10px;
          min-width: 250px;
        ">
          <div class="toast-content">
            <div class="toast-message"></div>
          </div>
        </div>
      `);

      // 安全地设置消息文本
      $toast.find(".toast-message").text(errorMessage);

      $("#toast-container").append($toast);

      setTimeout(() => {
        $toast.addClass("show");
      }, 10);

      setTimeout(() => {
        $toast.removeClass("show");
        setTimeout(() => {
          $toast.remove();
        }, 300);
      }, 5000);
    }

    showSuccess(message) {
      console.log("Auth Success:", message);

      // 确保 message 是字符串
      const successMessage =
        typeof message === "string" ? message : "Operation successful";

      // 创建 toast 元素
      const $toast = $(`
        <div class="game-toast success" style="
          margin-bottom: 10px;
          min-width: 250px;
        ">
          <div class="toast-content">
            <div class="toast-message"></div>
          </div>
        </div>
      `);

      // 安全地设置消息文本
      $toast.find(".toast-message").text(successMessage);

      $("#toast-container").append($toast);

      setTimeout(() => {
        $toast.addClass("show");
      }, 10);

      setTimeout(() => {
        $toast.removeClass("show");
        setTimeout(() => {
          $toast.remove();
        }, 300);
      }, 5000);
    }

    // 添加新方法检查用户名是否存在
    async checkUsernameExists(username, $hint) {
      try {
        const response = await $.ajax({
          url: gamehubVars.ajaxurl,
          type: "POST",
          data: {
            action: "gamehub_check_username",
            username: username,
            nonce: gamehubVars.nonce,
          },
        });

        if (response.success) {
          if (response.data.exists) {
            $hint
              .text("Username is already taken")
              .removeClass("success")
              .addClass("error");
          } else {
            $hint
              .text("Username is available")
              .removeClass("error")
              .addClass("success");
          }
        } else {
          $hint
            .text("Error checking username")
            .removeClass("success")
            .addClass("error");
        }
      } catch (error) {
        console.error("Username check error:", error);
        $hint
          .text("Error checking username")
          .removeClass("success")
          .addClass("error");
      }
    }
  }

  // 修改初始化方式，确保只初始化一次
  if (typeof window.AuthManager === "undefined") {
    window.AuthManager = AuthManager;

    // DOM 加载完成后初始化
    $(document).ready(() => {
      if (!window.authManager) {
        console.log("Initializing AuthManager...");
        try {
          window.authManager = new AuthManager();
        } catch (error) {
          console.error("Failed to initialize AuthManager:", error);
        }
      }
    });
  }
})(jQuery);
